module.exports = __webpack_public_path__ + "static/media/Manual_Product_Scan_QR.7911ff1c.png";